import ContractStats from './ContractStats';

export default ContractStats;
